import React, { FunctionComponent } from 'react'
import { connect } from 'react-redux'
import styled from '@emotion/styled'
import { createStructuredSelector } from 'reselect'
import * as constants from 'view/styles/constants'
import { SelectionActions } from 'store/selection'
import { createLeftNavigationMinimisedSelector } from 'selectors/selectionSelectors'
import { leftNavigationIconSet } from './leftNavigationIcons'
import { IconButton } from 'view/components/buttons'

const ToggleButton = styled(IconButton)`
  color: ${constants.CORE_PRIMARY_5};
  margin: 0 10px 4px 0px;
  &:hover {
    color: ${constants.ACCENT_PRIMARY};
  }
`

const mapStateToProps = createStructuredSelector({
  isLeftNavigationClosed: createLeftNavigationMinimisedSelector()
})

const mapDispatchToProps = {
  onToggleLeftNavigation: SelectionActions.toggleLeftNavigation
}

interface LeftNavigationToggleProps {
  isLeftNavigationClosed: boolean
  onToggleLeftNavigation: () => unknown
}

const LeftNavigationToggleComponent: FunctionComponent<LeftNavigationToggleProps> = ({ onToggleLeftNavigation }) => {
  return <ToggleButton onClick={onToggleLeftNavigation}>{leftNavigationIconSet.hamburgerIcon}</ToggleButton>
}

export const LeftNavigationToggle = connect(mapStateToProps, mapDispatchToProps)(LeftNavigationToggleComponent)
